import React from "react";
import AuthGateway from "../components/AuthGateway/AuthGateway";

export default function LoginV2() {
  return <AuthGateway mode="login" />;
}


